import script from "./PublicActiveOffersView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicActiveOffersView.vue?vue&type=script&setup=true&lang=js"

import "./PublicActiveOffersView.vue?vue&type=style&index=0&id=55dcd3e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dcd3e6"]])

export default __exports__